import React from 'react';

const plans = [
  {
    name: 'Free',
    price: '$0',
    description: 'Build a useful foundation and experience the core workspace.',
    features: [
      'Access to available free modules',
      'Basic search',
      'Core personalization options',
      'RadOnc Brain beta access',
    ],
    cta: 'Start free',
    featured: false,
  },
  {
    name: '1MED Pro',
    price: '$9.99',
    description: 'Go further with a richer, more personal medical library.',
    features: [
      'Access to available premium modules',
      'Advanced search and filters',
      'Expanded personalization options',
      'Content creation tools',
      'Enhanced collaboration options',
      'Priority support',
    ],
    cta: 'Choose Pro',
    featured: true,
  },
];

const PricingSection: React.FC = () => {
  return (
    <section id="pricing" className="section-shell scroll-mt-20">
      <div className="site-container">
        <div className="mx-auto max-w-2xl text-center">
          <p className="section-kicker">Pricing</p>
          <h2 className="section-title">Start free. Upgrade when your library asks for more.</h2>
          <p className="section-copy mt-4">
            Explore the core 1MEDICINE experience at no cost, then unlock premium modules,
            deeper personalization, and expanded creation tools with Pro.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2">
          {plans.map((plan) => (
            <article
              key={plan.name}
              className={`surface-card relative flex flex-col p-6 sm:p-7 ${
                plan.featured ? 'border-emerald-300 ring-1 ring-emerald-100' : ''
              }`}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">{plan.name}</h3>
                  <p className="mt-2 text-sm leading-6 text-slate-600">{plan.description}</p>
                </div>
                {plan.featured && (
                  <span className="shrink-0 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">
                    Most popular
                  </span>
                )}
              </div>

              <div className="mt-6 border-y border-slate-100 py-5">
                <span className="text-4xl font-semibold tracking-tight text-slate-900">{plan.price}</span>
                <span className="ml-2 text-sm text-slate-500">per month</span>
              </div>

              <ul className="my-6 flex-1 space-y-3">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex gap-3 text-sm text-slate-600">
                    <svg aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m5 12 4 4L19 6" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              <a
                href="https://1medicine.app"
                target="_blank"
                rel="noopener noreferrer"
                className={plan.featured ? 'primary-button w-full' : 'secondary-button w-full'}
              >
                {plan.cta}
              </a>
            </article>
          ))}
        </div>
        <p className="mx-auto mt-5 max-w-2xl text-center text-xs leading-5 text-slate-500">
          Module availability and plan details may change. Review current terms in the app before subscribing.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
